import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiInterceptorConstants} from '../constants/interceptors/api-interceptor.constants';

@Injectable()
export class ApiVersionInterceptor implements HttpInterceptor {

  firstVersion: number = 1;

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (this.featureIntegrationCheckAppConfig(request)) {
      return next.handle(request);
    }

    if (this.featureIntegrationCheckHealthCheck(request)) {
      return next.handle(request);
    }

    if (this.featureIntegrationCheckDboV2HealthCheck(request)) {
      return next.handle(request);
    }

    if (this.featureIntegrationCheckGraphApi(request)) {
      return next.handle(request);
    }

    if(this.CheckRequestBelongsToDboV2Api(request)){
      return next.handle(request.clone({
        url: `dbov2/api/v${this.firstVersion}/${request.url.replace('dbov2/', '')}`
      }));
    }

    if(this.CheckRequestBelongsToErpApi(request)){
      return next.handle(request.clone({
        url: `erp/api/v${this.firstVersion}/${request.url.replace('erp/', '')}`
      }));
    }

    if(this.CheckRequestBelongsToTmtApi(request)){
      return next.handle(request.clone({
        url: `tmt/api/v${this.firstVersion}/${request.url.replace('tmt/', '')}`
      }));
    }

    if (this.CheckRequestBelongsToN8nApi(request)) {
      return next.handle(request);
    }
    return next.handle(request.clone({
      url: `api/v${this.firstVersion}/${request.url}`
    }));
  }

  private featureIntegrationCheckAppConfig(request: HttpRequest<unknown>): boolean {
    return request.url.includes('appconfig');
  }

  private featureIntegrationCheckHealthCheck(request: HttpRequest<unknown>): boolean {
    return request.url.includes('trx/health');
  }

  private featureIntegrationCheckDboV2HealthCheck(request: HttpRequest<unknown>): boolean {
    return request.url.includes('dbov2/health');
  }

  private featureIntegrationCheckGraphApi(request: HttpRequest<unknown>): boolean {
    return request.url.includes('graph');
  }

  private CheckRequestBelongsToDboV2Api(request: HttpRequest<unknown>): boolean {
    return request.url.includes('dbov2/');
  }

  private CheckRequestBelongsToErpApi(request: HttpRequest<unknown>): boolean {
    return request.url.startsWith('erp/');
  }

  private CheckRequestBelongsToTmtApi(request: HttpRequest<unknown>): boolean {
    return request.url.includes('tmt/');
  }

  private CheckRequestBelongsToN8nApi(request: HttpRequest<unknown>): boolean {
    return request.url.includes(ApiInterceptorConstants.N8nHackathonRoute);
  }
}
